export let PricingType;
(function (PricingType) {
  PricingType["Free"] = "free";
  PricingType["Plan"] = "plan";
  PricingType["Subscription"] = "subscription";
})(PricingType || (PricingType = {}));
//# sourceMappingURL=pricing-type.js.map